<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-roya">
            <CIcon name="cil-credit-card" />
            Payment Roya
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Create</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CCard class="custom-form-card mb-4">
        <CCardBody class="px-3">
          <CRow>
            <CCol class="col-sm-12 pt-2">
              <b-form-group
                invalid-feedback="This input is required."
                :state="filter.mou.isValid"
                label="MOU"
                label-for="invoice-mou"
                class="mb-0"
              >
                <multiselect 
                  v-model="filter.mou.value" 
                  :options="filter.mou.options" 
                  :state="filter.mou.isValid"
                  class="mb-0"
                  :class="{custom_multiselect_invalid: filter.mou.isValid === false}"
                  :disabled="filter.isDisabled"
                  id="invoice-mou"
                  placeholder="Select an option"
                  :showLabels="false"
                  :loading="!filter.mou.isLoaded"
                  openDirection="bottom"
                  label="notaryName"
                  track-by="mouId"
                  :internalSearch="false"
                  :preserveSearch="false"
                  @search-change="populateMou"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.mouId + ' | ' + props.option.mouNo + ' | ' + props.option.notaryCode + ' | ' + props.option.notaryName }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.mouId + ' | ' + props.option.mouNo + ' | ' + props.option.notaryCode + ' | ' + props.option.notaryName }}</template>
                  <template slot="noResult">No elements found.</template>
                  <template slot="afterList" v-if="filter.mou.currentPage < filter.mou.totalPages">
                    <div class="text-center custom-cursor-clickable p-2" @click="appendSelectMou" v-if="filter.mou.isLoaded">
                      <span class="text-muted">Load More</span>
                    </div>
                    <div class="text-center" v-else>
                      <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                    </div>
                  </template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-md-12 col-lg-6 pt-3">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tipe Kontrak"
                label-for="invoice-contractType"
                :state="filter.contractType.isValid"
              >
                <multiselect 
                  v-model="filter.contractType.value" 
                  :options="filter.contractType.options" 
                  :class="{custom_multiselect_invalid: filter.contractType.isValid === false}"
                  :disabled="true"
                  id="invoice-contractType"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                </multiselect>
              </b-form-group>
            </CCol>
            <CCol class="col-md-12 col-lg-6 pt-3">
              <b-form-group
                invalid-feedback="This input is required."
                :state="filter.office.isValid"
                label="Office"
                label-for="invoice-office"
                class="mb-0"
              >
                <multiselect 
                  v-model="filter.office.value" 
                  :options="filter.office.options" 
                  :state="filter.office.isValid"
                  class="mb-0"
                  :class="{custom_multiselect_invalid: filter.office.isValid === false}"
                  :disabled="filter.isDisabled"
                  id="invoice-office"
                  placeholder="Select an option"
                  :showLabels="false"
                  :loading="!filter.office.isLoaded"
                  openDirection="bottom"
                  label="nameFull"
                  track-by="officeCode"
                  :internalSearch="false"
                  :preserveSearch="false"
                  @search-change="populateOffice"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                  <template slot="noResult">No elements found.</template>
                  <template slot="afterList" v-if="filter.office.currentPage < filter.office.totalPages">
                    <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="filter.office.isLoaded">
                      <span class="text-muted">Load More</span>
                    </div>
                    <div class="text-center" v-else>
                      <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                    </div>
                  </template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-3">
            <CCol class="col-md-12 col-lg-4">
              <b-form-group
                invalid-feedback="This input is required."
                label="Company"
                label-for="invoice-company"
                :state="filter.company.isValid"
              >
                <multiselect 
                  v-model="filter.company.value" 
                  :options="filter.company.options" 
                  :class="{custom_multiselect_invalid: filter.company.isValid === false}"
                  :disabled="filter.isDisabled"
                  id="invoice-company"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                </multiselect>
              </b-form-group>
            </CCol>
            <CCol class="col-md-12 col-lg-4">
              <b-form-group
                invalid-feedback="This input is required."
                label="Business Unit"
                label-for="invoice-platform"
                :state="filter.bussUnit.isValid"
              >
                <multiselect 
                  v-model="filter.bussUnit.value" 
                  :options="filter.bussUnit.options" 
                  :class="{custom_multiselect_invalid: filter.bussUnit.isValid === false}"
                  :disabled="filter.isDisabled"
                  id="invoice-bussUnit"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                </multiselect>
              </b-form-group>
            </CCol>
            <CCol class="col-md-12 col-lg-4">
              <b-form-group
                invalid-feedback="This input is required."
                label="Platform"
                label-for="invoice-platform"
                :state="filter.platform.isValid"
              >
                <multiselect 
                  v-model="filter.platform.value" 
                  :options="filter.platform.options" 
                  :class="{custom_multiselect_invalid: filter.platform.isValid === false}"
                  :disabled="filter.isDisabled"
                  id="invoice-platform"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                  @input="onInputFilter"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-sm-12">
              <b-alert variant="info" show>Jumlah kontrak yang dapat dipilih maksimum {{maxContract}} kontrak</b-alert>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-sm-12">
              <b-table striped hover show-empty
                responsive="xl"
                :items="table.items"
                :fields="table.fields"
                :busy="!table.isLoaded"
                no-local-sorting no-sort-reset
                @sort-changed="onSortChanged"
              >
              <template #cell(customerName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(assignmentDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
                <template slot="empty">
                  <div v-if="!table.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Tidak ada data
                  </div> 
                </template>
                <template #cell(action)="row">
                  <b-form-checkbox v-if="!row.item.isLoading" :state="row.item.checkboxState" size="md" v-on:change="setSelectedItem(row.index)" @change="addRemoveItem" :checked="table.selectedItems.indexOf(row.item.contractId) != -1" :disabled="disableContract && table.selectedItems.indexOf(row.item.contractId) == -1"></b-form-checkbox>
                  <b-spinner v-else small label="Loading..."></b-spinner>
                </template>
              </b-table>
              <CCardFooter>
                <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @page-change="onPageChange" />
              </CCardFooter>
            </CCol>
          </CRow>
          <CRow class="pt-3">
            <CCol>
              <b-form-group
                invalid-feedback="This input is required."
                label="Notes"
                label-for="invoice-note"
                :state="notes.isValid"
              >
                <b-form-textarea
                  v-model="notes.value"
                  :state="notes.isValid"
                  placeholder="Notes"
                  id="invoice-note"
                  rows="3"
                  max-rows="3"
                  maxlength="500"
                ></b-form-textarea>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="pt-3">
            <CCol class="col-12">
              <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="createInvoice">
                <b-spinner small v-if="isSubmitting" />
                {{ isSubmitting ? 'Sedang diproses...' : 'Submit' }}
              </CButton>
              <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({name: 'Invoice Roya List'})">Cancel</b-btn>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceRoyaAdd',
  data() {
    return {

      timerObject: undefined,

      refreshLockContractInterval: 240000, // 4 minutes or 240 seconds

      isSubmitting: false,

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],

      notes: {
        value: '',
        isValid: null,
        isRequired: false,
        payloadKey: "notes"
      },

      filter: {

        isDisabled: false,

        mou: {
          value: null,
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "mouId"
        },
        contractType: {
          value: { value: 'R', text: 'Roya' },
          isValid: null,
          isRequired: true,
          options: [
            { value: 'F', text: 'Fiducia' },
            { value: 'R', text: 'Roya' },
            { value: 'A', text: 'APHT' },
          ],
          payloadKey: "contractType"
        },
        office: {
          value: null,
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "officeCode"
        },
        company: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "coyId"
        },
        bussUnit: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "bussUnit"
        },
        platform: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "platformId"
        },
      },

      table: {

        isLoaded: false,

        selectedItem: null,
        selectedItemIndex: -1,
        selectedItems: [],

        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Office", sortable: true},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0,

        disableContract: false,
        maxContract: 0,
      },
    }
  },
  methods: {

    createInvoice(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {
        // lockKey: localStorage.getItem(this.$lockKeyKeyword),
        lockKey: this.$store.state.lockKey,
        listContractId: this.table.selectedItems,
        notes: !this.$helper.isEmpty(this.notes.value) ? this.notes.value : ''
      }

      // Validate Filter values
      for(const [key, data] of Object.entries(this.filter)){
        if (key == 'isDisabled') {
          continue
        } else{
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.isValid = false
            isFormValid = false
          } else{
            data.isValid = null
            if (key == 'mou') {
              if (data.value != null) {
                obj[data.payloadKey] = data.value.mouId
              } else{
                obj[data.payloadKey] = data.value
              }
            } else if (key == 'office') {
              if (data.value != null) {
                obj[data.payloadKey] = data.value.officeCode
              } else{
                obj[data.payloadKey] = data.value
              }
            } else{ // Contract Type, Company, Business Unit, Platform
              if (data.value != null) {
                obj[data.payloadKey] = data.value.value
              } else{
                obj[data.payloadKey] = data.value
              }
            }
          }
        }
      }

      if (this.table.selectedItems.length == 0) {
        this.table.items.forEach(obj => {
          obj.checkboxState = false
        })
        isFormValid = false
      }

      if (isFormValid) {

        if (this.table.items.length == 0) {
          return this.$helper.toastError(this, "Tidak ada Kontrak yang terpilih!")
        }

        let postUrl = '/payment/addInvoiceRoya/'
        this.isSubmitting = true
        this.$axios.post(postUrl, obj).then(response => {
          if(response.data.status){
            // this.$helper.toastSuccess(this, "Create Payment Berhasil! " + (response.data.reason ? response.data.reason : ""))
            // this.clearInput()

            this.$store.commit('set', ['toast', true])
            this.$store.commit('set', ['toastMsg', "Request Create Payment Telah Dikirim! " + (response.data.reason ? response.data.reason : "")])
            // this.$store.commit('set', ['toastMsg', "Create Payment Berhasil! " + (response.data.reason ? response.data.reason : "")])
            this.$router.push({ name: 'Invoice Roya List' });
          }
          else{
            this.$helper.toastError(this, "Create Payment Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Create Payment Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Create Payment Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      }
    },

    setSelectedItem(index) {
      this.table.selectedItem = this.table.items[index].contractId
      this.table.selectedItemIndex = index
    },

    async lockContract() {
      let contractId = this.table.selectedItem
      // let lockKey = localStorage.getItem(this.$lockKeyKeyword)
      let lockKey = this.$store.state.lockKey

      this.table.items[this.table.selectedItemIndex].isLoading = true
      let processUrl = "/payment/lockContract"
      let data = new FormData()
      data.set('contractId', contractId)
      data.set('contractType', 'R')
      data.set('lockKey', lockKey)
      return await this.$axios.post(processUrl, data).then((response) => {

        if (response.status === 200){
          return true
        } else {
          this.$helper.toastError(this, "Lock Contract Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          return false
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Lock Contract Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Lock Contract Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.items[this.table.selectedItemIndex].isLoading = false
      })
    },

    async unlockContract() {
      let contractId = this.table.selectedItem
      // let lockKey = localStorage.getItem(this.$lockKeyKeyword)
      let lockKey = this.$store.state.lockKey

      this.table.items[this.table.selectedItemIndex].isLoading = true
      let processUrl = "/payment/unlockContract"
      let data = new FormData()
      data.set('contractId', contractId)
      data.set('contractType', 'R')
      data.set('lockKey', lockKey)
      return await this.$axios.post(processUrl, data).then((response) => {

        if (response.status === 200){
          return true
        } else {
          this.$helper.toastError(this, "Unlock Contract Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          return false
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Unlock Contract Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Unlock Contract Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.items[this.table.selectedItemIndex].isLoading = false
      })
    },

    async refreshLockContract() {
      if (this.$route.name != "Invoice Add") {
        this.clearTimerObject()
        return
      }

      // let lockKey = localStorage.getItem(this.$lockKeyKeyword)
      let lockKey = this.$store.state.lockKey

      let processUrl = "/payment/refreshLockContract"
      let data = new FormData()
      data.set('contractType', 'R')
      data.set('lockKey', lockKey)
      return await this.$axios.post(processUrl, data).then((response) => {

        if (response.status === 200){
          return true
        } else {
          this.$helper.toastError(this, "Refresh Lock Contract Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          return false
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Refresh Lock Contract Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Refresh Lock Contract Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },

    async clearLockContract() {
      // let lockKey = localStorage.getItem(this.$lockKeyKeyword)
      let lockKey = this.$store.state.lockKey

      let processUrl = "/payment/clearLockContract"
      let data = new FormData()
      data.set('contractType', 'R')
      data.set('lockKey', lockKey)
      return await this.$axios.post(processUrl, data).then((response) => {

        if (response.status === 200){
          return true
        } else {
          this.$helper.toastError(this, "Clear Lock Contract Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          return false
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Clear Lock Contract Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Clear Lock Contract Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },

    async addRemoveItem(checked) {

      let add = false
      let success = checked ? await this.lockContract() : await this.unlockContract()

      if (success) {
        // If successfully lock / unlock contract, then continue:

        if (checked) {
          add = true
  
          this.table.selectedItems.push(this.table.selectedItem)

          // set all contract checkboxes state to null
          this.table.items.forEach(obj => {
            obj.checkboxState = null
          })

          // set all filter state to null
          for(const [key, data] of Object.entries(this.filter)){
            if (key == 'isDisabled') {
              continue
            } else{
              data.isValid = null
            }
          }
          
        } else{
  
          this.table.selectedItems.splice(this.table.selectedItems.indexOf(this.table.selectedItem), 1)
        }
  
        if (this.table.selectedItems.length == 0) {
          
          // Set filter values to null
          this.filter.mou.value = null
          this.filter.office.value = null
          this.filter.company.value = null
          this.filter.bussUnit.value = null
          this.filter.platform.value = null
  
          // Set filter isDisabled to false
          this.filter.isDisabled = false
  
        } else if (this.table.selectedItems.length == 1 && add){
  
          // Set filter values to rows specification
          let rowItem = this.table.items[this.table.selectedItemIndex]
  
          if (!this.$helper.isEmpty(rowItem.mouId)) this.filter.mou.value = { mouId: rowItem.mouId, mouNo: rowItem.mouNo, notaryCode: rowItem.notaryCode, notaryName: rowItem.notaryName}
          // this.filter.contractType.value = { value: rowItem.contractType, text: ''}
          // if (this.filter.contractType.value.value == 'F') {
          //   this.filter.contractType.value.text = 'Fiducia'
          // } else if (this.filter.contractType.value.value == 'R') {
          //   this.filter.contractType.value.text = 'Roya'
          // } else if (this.filter.contractType.value.value == 'A') {
          //   this.filter.contractType.value.text = 'APHT'
          // }
          if (this.$helper.isEmpty(this.filter.office.options.filter(obj => obj.value == rowItem.officeCode))) this.filter.office.options.push({ officeCode: rowItem.officeCode, nameFull: rowItem.officeName})
          this.filter.office.value = { officeCode: rowItem.officeCode, nameFull: rowItem.officeName}
          this.filter.company.value = { value: rowItem.coyId, text: rowItem.companyName}
          this.filter.bussUnit.value = { value: rowItem.bussUnit, text: rowItem.bussUnitDesc}
          this.filter.platform.value = { value: rowItem.platformId, text: rowItem.platformName}
  
          // Set filter isDisabled to true
          this.filter.isDisabled = true
          this.table.currentPage = 1
        }

        if(this.table.selectedItems.length >= this.maxContract){
          this.disableContract = true
        } else {
          this.disableContract = false
        }
  
        this.getTableItems(this.table.currentPage)
      }
    },

    onInputFilter() {
      this.getTableItems(this.table.currentPage)
    },

    populateOffice(query = "") {
      this.filter.office.isLoaded = false
      this.filter.office.totalPages = 0
      this.filter.office.totalRows = 0
      this.filter.office.currentPage = 1
      this.filter.office.lastQuery = query
      // URL builder
      let getUrl = "/office/getAll"

      let params = this.$helper.getBasePagedQuery(this.filter.office.currentPage - 1, this.filter.office.perPage)
      if(query !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = query
      }

      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.filter.office.options = []
          for(let i = 0; i < response.data.data.data.length; i++){
            this.filter.office.options.push(response.data.data.data[i])
          }
          this.filter.office.totalRows = response.data.data.totalElements
          this.filter.office.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.filter.office.isLoaded = true
      })
    },

    populateMou(query = "") {
      this.filter.mou.isLoaded = false
      this.filter.mou.totalPages = 0
      this.filter.mou.totalRows = 0
      this.filter.mou.currentPage = 1
      this.filter.mou.lastQuery = query
      // URL builder
      let getUrl = "/mou/getMouForInvoice"
      
      let params = this.$helper.getBasePagedQuery(this.filter.mou.currentPage - 1, this.filter.mou.perPage)
      if(query !== ""){
        params['filterType'] = "nameCodeNo"
        params['filterValue'] = query
      }

      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.filter.mou.options = []
          for(let i = 0; i < response.data.data.data.length; i++){
            this.filter.mou.options.push(response.data.data.data[i])
          }
          this.filter.mou.totalRows = response.data.data.totalElements
          this.filter.mou.totalPages = response.data.data.totalPages
        }
        else{
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.filter.mou.isLoaded = true
      })
    },

    appendSelectOffice() {
      this.filter.office.isLoaded = false
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.filter.office.currentPage, this.filter.office.perPage)
      if(this.filter.office.lastQuery !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = this.filter.office.lastQuery
      }
      
      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          for(let i = 0; i < response.data.data.data.length; i++){
            this.filter.office.options.push(response.data.data.data[i])
          }
          this.filter.office.currentPage++
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.filter.office.isLoaded = true
      })
    },

    appendSelectMou() {
      this.filter.mou.isLoaded = false
      // URL builder
      let getUrl = "/mou/getMouForInvoice"
      
      let params = this.$helper.getBasePagedQuery(this.filter.mou.currentPage, this.filter.mou.perPage)
      if(this.filter.mou.lastQuery !== ""){
        params['filterType'] = "name"
        params['filterValue'] = this.filter.mou.lastQuery
      }
      // get content from next page
      params['page'] = (this.filter.mou.currentPage)
      params['size'] = this.filter.mou.perPage
      if(this.filter.mou.lastQuery !== ""){
        params['filterType'] = "nameCodeNo"
        params['filterValue'] = this.filter.mou.lastQuery
      }

      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          for(let i = 0; i < response.data.data.data.length; i++){
            this.filter.mou.options.push(response.data.data.data[i])
          }
          this.filter.mou.currentPage++
        }
        else{
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar MOU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.filter.mou.isLoaded = true
      })
    },

    // get all, no pagination
    populateBussUnit() {
      // URL builder
      let getUrl = "/bussUnit/getAll"
      this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.filter.bussUnit.options = []
          for(let i = 0; i < response.data.data.length; i++){
            this.filter.bussUnit.options.push({
              value: response.data.data[i].bussUnit,
              text: response.data.data[i].bussUnitDesc
            })
          }
        }
        else{
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
      })
    },
    
    populateCompany() {
      // URL builder
      let getUrl = "/company/getAll"
      this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.filter.company.options = []
          for(let i = 0; i < response.data.data.length; i++){
            this.filter.company.options.push({
              value: response.data.data[i].id,
              text: response.data.data[i].name
            })
          }
        }
        else{
          this.$helper.toastError(this, "Load Daftar Company Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Company Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Company Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
      })
    },

    populatePlatform() {
      // URL builder
      let getUrl = "/platform/getAll"
      this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.filter.platform.options = []
          for(let i = 0; i < response.data.data.length; i++){
            this.filter.platform.options.push({
              value: response.data.data[i].id,
              text: response.data.data[i].name
            })
          }
        }
        else{
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
      })
    },

    getMaxContract() {
      let getUrl = "/payment/getMaxContract"
      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          this.maxContract = response.data.data
        }
      })
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/payment/getContractRoyaToCreateInvoice"

      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }

      if (!this.$helper.isEmpty(this.filter.mou.value)) params['mouId'] = this.filter.mou.value.mouId
      if (!this.$helper.isEmpty(this.filter.contractType.value)) params['contractType'] = this.filter.contractType.value.value
      if (!this.$helper.isEmpty(this.filter.office.value)) params['officeCode'] = this.filter.office.value.officeCode
      if (!this.$helper.isEmpty(this.filter.company.value)) params['coyId'] = this.filter.company.value.value
      if (!this.$helper.isEmpty(this.filter.bussUnit.value)) params['bussUnit'] = this.filter.bussUnit.value.value
      if (!this.$helper.isEmpty(this.filter.platform.value)) params['platformId'] = this.filter.platform.value.value

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.table.items = response.data.data.data.map(obj => {
            obj.isLoading = false
            obj.checkboxState = null
            return obj
          })
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      this.getTableItems()
    },
  
    onPageChange(newPage) {
      this.getTableItems(newPage)
    },

    clearTimerObject() {
      clearInterval(this.timerObject)
    },
  },
  computed: {

  },
  mounted() {
    this.getTableItems()
    this.populateCompany()
    this.populateBussUnit()
    this.populatePlatform()
    this.populateOffice()
    this.populateMou()
    this.getMaxContract()
  },
  created(){
    this.clearLockContract()
    this.timerObject = setInterval(() => {
      this.refreshLockContract()
    }, this.refreshLockContractInterval)
  }
}
</script>

<style>

</style>
